module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhand1-9ec9596079d4ff330f5722141c6389f5.jpg";